import React from "react";

const UserLoaderBox = ({ classe }) => {
  return (
    <article className={`${classe} flex animate-pulse items-center space-x-2`}>
      <div className="h-10 w-10 rounded-full bg-smoot"></div>
      <div className="flex flex-col space-y-2">
        <p className="h-3 w-[120px] rounded  bg-smoot"></p>
        <span className="block h-3 w-[190px] rounded bg-smoot"></span>
      </div>
    </article>
  );
};

export default UserLoaderBox;
